import styled from 'styled-components';
import { getBorderStyle } from '../Checkbox/Checkbox.styles';

export const RadioContainer = styled.div<{
  disabled?: boolean;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
}>`
  /* margin: 20px 0; */
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  align-items: center;
`;

export const OuterCircle = styled.div<{
  checked?: boolean;
  disabled?: boolean;
  $circleColor?: string;
}>`
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border: ${({ disabled, checked, $circleColor }) =>
    getBorderStyle(disabled, checked, $circleColor)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  transition: all 0.1s linear;
`;

export const InnerCircle = styled.div<{
  checked?: boolean;
  disabled?: boolean;
}>`
  width: ${({ checked }) => (checked ? '10px' : '0px')};
  height: ${({ checked }) => (checked ? '10px' : '0px')};
  border-radius: 50%;
  background-color: ${({ disabled }) =>
    disabled ? 'rgba(0, 0, 0, 0.125)' : '#009ace'};
  transition: all 0.1s linear;
  &:disabled {
    color: rgba(0, 0, 0, 0.125);
  }
`;

export const Label = styled.div<{ disabled?: boolean; checked?: boolean }>`
  color: ${({ disabled }) =>
    disabled ? 'rgba(0, 0, 0, 0.125)' : 'rgba(0, 0, 0, 0.93)'};
  padding-right: 8px;

  &:disabled {
    color: rgba(0, 0, 0, 0.125);
  }

  font-weight: ${({ checked }) => (checked ? 500 : 400)};
`;
